/*
 * @Description: 双创跳转到量子云的逻辑
 * @Author: ywj
 * @Date: 2022-01-18 14:23:58
 */
import url from 'url';
import { message } from 'antd';
import Http from '../plugins/axiosHttp';

export const scMemberV1Jump = (type, version, getUserMessage) => {
  // console.log(type, 'type');
  // const _this = type;
  const scLocation = window.location.search;
  const scSearch = url.parse(window.location.search, true);
  const scToken = version === 'v2' ? scSearch.query.scToken : scSearch.query.sc_v1Token;
  // window.history.pushState('', '',window.location.pathname + '?qpu=1');
  Http.get('uc/sso/scLogin.json?scToken=' + scToken).then(res => {
    // console.log(res, 'sso/scLogin.json');
    // getUserMessage();
    if (res.data.success) {
      // 双创退出登录，去掉链接参数
      if (scLocation.includes('sc_v1Token') || scLocation.includes('scToken')) {
        let newUrl1 = window.location.origin + window.location.pathname;
        if (scLocation.indexOf('qpu=1') > -1) {
          newUrl1 = window.location.origin + window.location.pathname + '?qpu=1';// 双创芯片打开抽屉事件,qvm使用
        }
        try {
          if (scLocation.indexOf('qpu=1') > -1) {
            window.history.pushState('', '', window.location.pathname + '?qpu=1');
          } else {
            window.history.pushState('', '', window.location.pathname);
          }
        } catch (e) {
          window.location.href = newUrl1;
        }
      }
      if (getUserMessage) {
        getUserMessage();
      }
    } else {
      message.warning(res.data.message);
    }
  });
};

export const sgMemberV1Jump = (getUserMessage, setSgState, setSugonData) => {
  // console.log(type, 'type');
  // const _this = type;
  // const scLocation = window.location.search;
  const sgSearch = url.parse(window.location.search, true);
  const token = sgSearch.query.token;
  Http.get('uc/third/sgLogin.json?sugonToken=' + token).then(res => {
    const result = res.data;
    if (result.success) {
      if (token) {
        const newUrl1 = window.location.origin + window.location.pathname;
        try {
          window.history.pushState('', '', window.location.pathname);
        } catch (e) {
          window.location.href = newUrl1;
        }
      }
      if (getUserMessage) {
        getUserMessage();
      }
    } else {
      if (result.code === 10001) {
        const newUrl = window.location.origin + window.location.pathname;
        try {
          window.history.pushState('', '', window.location.pathname);
        } catch (e) {
          window.location.href = newUrl;
        }
      } else if (result.code === 10083) {
        setSgState(true);
        setSugonData({ ...result.obj });
      } else {
        message.warning(result.message);
      }
    }
  });
};


export default scMemberV1Jump;